import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * OAuth callback handler for atlas.
 *
 * Success path: Supabase JS parses tokens from the URL hash; the authStore
 * onAuthStateChange handles SIGNED_IN, then we redirect to the client home.
 * Signup-disabled path (OAuth when Supabase has signups off): Supabase
 * redirects back with the error in the hash; route to /login so the
 * invite-only notice renders.
 */
const SIGNUP_DISABLED_PATTERN = /signup_disabled|signups?\s+not\s+allowed/i;

export function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash.startsWith('#')
      ? window.location.hash.slice(1)
      : window.location.hash;
    const params = new URLSearchParams(hash);
    const errorCode = params.get('error_code') ?? '';
    const errorDesc = decodeURIComponent(params.get('error_description') ?? '');

    if (SIGNUP_DISABLED_PATTERN.test(errorCode) || SIGNUP_DISABLED_PATTERN.test(errorDesc)) {
      navigate('/login', { replace: true, state: { signupBlocked: true } });
      return;
    }

    const timer = setTimeout(() => navigate('/', { replace: true }), 1500);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#1C1B19' }}>
      <div className="text-center">
        <svg className="animate-spin h-8 w-8 mx-auto mb-4" style={{ color: '#C4654A' }} viewBox="0 0 24 24" fill="none">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
        <p className="text-sm" style={{ color: '#8A857C' }}>A autenticar...</p>
      </div>
    </div>
  );
}
